import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import EventAnalyticsPanel from '../components/dashboard/EventAnalyticsPanel';
import { selectAuthUserId } from '../redux/authSlice';
import { selectCourses } from '../redux/coursesSlice';
import { fetchUserAnalyticsSnapshot } from '../services/supabaseClient/eventAnalyticsService';
import './Dashboard.css';

const AnalyticsPage = () => {
  const userId = useSelector(selectAuthUserId);
  const courses = useSelector(selectCourses);
  const [analyticsWindowDays, setAnalyticsWindowDays] = useState(30);
  const [analyticsLoading, setAnalyticsLoading] = useState(false);
  const [analyticsError, setAnalyticsError] = useState('');
  const [analytics, setAnalytics] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadAnalytics = async () => {
      if (!userId) {
        if (isMounted) {
          setAnalytics(null);
          setAnalyticsLoading(false);
          setAnalyticsError('');
        }
        return;
      }

      setAnalyticsLoading(true);
      setAnalyticsError('');

      const { data, error } = await fetchUserAnalyticsSnapshot({
        userId,
        days: analyticsWindowDays,
        courses,
      });

      if (!isMounted) return;

      if (error) {
        setAnalyticsError(error.message || 'Failed to load analytics.');
      } else {
        setAnalytics(data);
      }

      setAnalyticsLoading(false);
    };

    loadAnalytics();

    return () => {
      isMounted = false;
    };
  }, [analyticsWindowDays, courses, userId]);

  return (
    <Container className="analytics-page py-5">
      <EventAnalyticsPanel
        analytics={analytics}
        days={analyticsWindowDays}
        onDaysChange={setAnalyticsWindowDays}
        loading={analyticsLoading}
        error={analyticsError}
      />
    </Container>
  );
};

export default AnalyticsPage;
